import {INotificationTypeStrategyFactory} from '@toolify/client/src/stores/NotificationStore/types/INotificationTypeStrategyFactory'
import {INotificationTypeStrategy} from '@toolify/client/src/stores/NotificationStore/types/INotificationTypeStrategy'
import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {UserAssignedToDatabaseItemNotificationStrategy} from '@toolify/client/src/stores/NotificationStore/strategies/UserAssignedToDatabaseItemNotificationStrategy'
import {MentionedInMessageNotificationStrategy} from '@toolify/client/src/stores/NotificationStore/strategies/MentionedInMessageNotificationStrategy'
import {MentionedInDocumentNotificationStrategy} from '@toolify/client/src/stores/NotificationStore/strategies/MentionedInDocumentNotificationStrategy'
import {MentionedInMarkdownNotificationStrategy} from '@toolify/client/src/stores/NotificationStore/strategies/MentionedInMarkdownNotificationStrategy'
import {NewMessageNotificationStrategy} from '@toolify/client/src/stores/NotificationStore/strategies/NewMessageNotificationStrategy'
import {ExportedDatabaseNotificationStrategy} from '../strategies/ExportedDatabase'
import {DatabaseItemValueUpdatedNotificationStrategy} from '../strategies/DatabaseItemValueUpdatedNotificationStrategy'
import {
  IncomingCallNotificationStrategy,
} from '@toolify/client/src/stores/NotificationStore/strategies/IncomingCallNotificationStrategy'
import {DatabaseItemCreatedNotificationStrategy} from '../strategies/DatabaseItemCreatedNotificationStrategy'
import {UserAssigneeChangedOnDatabaseItemNotificationStrategy} from '../strategies/UserAssigneeChangedOnDatabaseItemNotificationStrategy'
import {StatusChangedOnDatabaseItemNotificationStrategy} from '../strategies/StatusChangedOnDatabaseItemNotificationStrategy'
import {LabelChangedOnDatabaseItemNotificationStrategy} from '../strategies/LabelChangedOnDatabaseItemNotificationStrategy'
import {DatabaseItemDateChangedNotificationStrategy} from '../strategies/DatabaseItemDateChangedNotificationStrategy'
import {RepliedToMyMessageNotificationStrategy} from '../strategies/RepliedToMyMessageNotificationStrategy'
import {DatabaseItemDeletedNotificationStrategy} from '../strategies/DatabaseItemDeletedNotificationStrategy'
import {CloudItemCreatedNotificationStrategy} from '../strategies/CloudItemCreatedNotificationStrategy'
import {CloudItemDeletedNotificationStrategy} from '../strategies/CloudItemDeletedNotificationStrategy'
import {DatabaseItemFileCreatedNotificationStrategy} from '../strategies/DatabaseItemFileCreatedNotificationStrategy'
import {DatabaseItemFileDeletedNotificationStrategy} from '../strategies/DatabaseItemFileDeletedNotificationStrategy'
import {WorkspaceAppAccessRequestPendingNotificationStrategy} from '../strategies/WorkspaceAppAccessRequestPendingNotificationStrategy'
import {WorkspacePermissionRequestPendingNotificationStrategy} from '../strategies/WorkspacePermissionRequestPendingNotificationStrategy'
import {AppVersionPublishedNotificationStrategy} from '../strategies/AppVersionPublishedNotificationStrategy'
import {AiApprovalRequestedNotificationStrategy} from '../strategies/AiApprovalRequestedNotificationStrategy'
import {AiRunFinishedNotificationStrategy} from '../strategies/AiRunFinishedNotificationStrategy'

export class NotificationTypeStrategyFactory implements INotificationTypeStrategyFactory {
  getStrategy(type: NotificationType): INotificationTypeStrategy {
    switch (type) {
    case NotificationType.UserAssignedToDatabaseItem:
      return new UserAssignedToDatabaseItemNotificationStrategy()
    case NotificationType.MentionedInMessage:
      return new MentionedInMessageNotificationStrategy()
    case NotificationType.MentionedInDocument:
      return new MentionedInDocumentNotificationStrategy()
    case NotificationType.MentionedInMarkdown:
      return new MentionedInMarkdownNotificationStrategy()
    case NotificationType.NewMessage:
      return new NewMessageNotificationStrategy()
    case NotificationType.ExportedDatabase:
      return new ExportedDatabaseNotificationStrategy()
    case NotificationType.DatabaseItemValueUpdated:
      return new DatabaseItemValueUpdatedNotificationStrategy()
    case NotificationType.IncomingCall:
      return new IncomingCallNotificationStrategy()
    case NotificationType.DatabaseItemCreated:
      return new DatabaseItemCreatedNotificationStrategy()
    case NotificationType.UserAssigneeChangedOnDatabaseItem:
      return new UserAssigneeChangedOnDatabaseItemNotificationStrategy()
    case NotificationType.StatusChangedOnDatabaseItem:
      return new StatusChangedOnDatabaseItemNotificationStrategy()
    case NotificationType.LabelChangedOnDatabaseItem:
      return new LabelChangedOnDatabaseItemNotificationStrategy()
    case NotificationType.DatabaseItemDateChanged:
      return new DatabaseItemDateChangedNotificationStrategy()
    case NotificationType.RepliedToMyMessage:
      return new RepliedToMyMessageNotificationStrategy()
    case NotificationType.DatabaseItemDeleted:
      return new DatabaseItemDeletedNotificationStrategy()
    case NotificationType.CloudItemCreated:
      return new CloudItemCreatedNotificationStrategy()
    case NotificationType.CloudItemDeleted:
      return new CloudItemDeletedNotificationStrategy()
    case NotificationType.DatabaseItemFileCreated:
      return new DatabaseItemFileCreatedNotificationStrategy()
    case NotificationType.DatabaseItemFileDeleted:
      return new DatabaseItemFileDeletedNotificationStrategy()
    case NotificationType.WorkspaceAppAccessRequestPending:
      return new WorkspaceAppAccessRequestPendingNotificationStrategy()
    case NotificationType.WorkspacePermissionRequestPending:
      return new WorkspacePermissionRequestPendingNotificationStrategy()
    case NotificationType.AppVersionPublished:
      return new AppVersionPublishedNotificationStrategy()
    case NotificationType.AiApprovalRequested:
      return new AiApprovalRequestedNotificationStrategy()
    case NotificationType.AiRunFinished:
      return new AiRunFinishedNotificationStrategy()
    default:
      throw new Error(`Strategy for notification type "${type}" is not implemented`)
    }
  }
}
